import { FC, useMemo } from 'react';
import { Typography, TypographyProps } from '@mui/material';


interface Props extends TypographyProps {
  text?: string;
}

export const WordCount: FC<Props> = ({ text, ...typographyProps }) => {
  const wordCount = useMemo(() => {
    const trimmedText = text?.trim();
    return trimmedText ? trimmedText.split(/\s+/).filter(Boolean).length : 0;
  }, [text]);

  return (
    <Typography variant="caption" color="textSecondary" {...typographyProps}>
      {wordCount} word{wordCount === 1 ? '' : 's'}
    </Typography>
  );
};
